// The Halloween homepage replaces HomeComponent at "/" for one week, Pacific time:
// Mon 2026-10-26 00:00 PDT (UTC-7) through Sun 2026-11-01 23:59 PST (UTC-8; DST ends Nov 1).
export const HALLOWEEN_HOME_START = Date.UTC(2026, 9, 26, 7);
export const HALLOWEEN_HOME_END = Date.UTC(2026, 10, 2, 8);

export function isHalloweenHomeActive(now: number = Date.now()): boolean {
  return now >= HALLOWEEN_HOME_START && now < HALLOWEEN_HOME_END;
}
